module.exports = __webpack_public_path__ + "img/Card_diamond_A.2655f292.svg";